/* global setupSF referenceSetter closeSuccessPopup */
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported
import "./Banner.css"; // Import the existing CSS file for additional custom styles
import SimpleGrid from "./Timeline";
import { Accordion, Container,Row, Col } from 'react-bootstrap';
import { db } from "./firebase"; // Import Firestore
import { collection, query, where, getDocs, addDoc } from "firebase/firestore"; // Functions to interact with Firestore
import RegistrationForm from './components/registrationForm';
import Roadmap from './components/roadmap';
import CustomAccordion from './accordian';
import SnowflakeAccordion from './accordian3';
import SimpleAccordion from './accordian2';





const Banner2 = () => {
   const [liveClassInfo, setLiveClassInfo] = useState({
    date: "Loading...",
    time: "Loading...",
    dateString: "Loading...",
  });
  const [coursePrice, setCoursePrice] = useState({
    previousPrice: 0,
    currentPrice: 0,
  });

  useEffect(() => {
  // Firestore data fetching logic
  const fetchLiveClassInfo = async () => {
    try {
      const q = query(collection(db, "courseSchedules"), where("name", "==", "Data Engineering"));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const docData = querySnapshot.docs[0].data();
        setLiveClassInfo({
          date: docData.date,
          time: docData.time,
          dateString: docData.dateString,
        });
        setCoursePrice({
          previousPrice: docData.previousPrice || 0,
          currentPrice: docData.currentPrice || 0,
        });
      } else {
        console.error("No matching document found!");
      }
    } catch (error) {
      console.error("Error fetching live class data:", error);
    }
  };

  fetchLiveClassInfo(); // Call the function to fetch data

  // Define the functions before using them
  window.runOnFormSubmit_sf3zbfbf380341be986d6327361241b0ac5419f4a25c5c92bd5b8488df5a5eb40999 = (th) => {
    console.log('Form submitted:', th);
  };

  window.closeSuccessPopup = () => {
    const popup = document.getElementById('zcOptinSuccessPopup');
    if (popup) {
      popup.style.display = 'none';
    }
  };

  window.referenceSetter = (el) => {
    console.log('Reference set:', el);
  };

  // Zoho script loading logic
  const script = document.createElement('script');
  script.src = "https://ma.zoho.in/js/optin.min.js";
  script.async = true;
  script.onload = () => {
    if (typeof window.setupSF === 'function') {
      window.setupSF('sf3zbfbf380341be986d6327361241b0ac5419f4a25c5c92bd5b8488df5a5eb40999', 'ZCFORMVIEW', false, 'light');
    }
  };
  document.body.appendChild(script);

  // Cleanup function to remove the script when the component unmounts.
  return () => {
    document.body.removeChild(script);
  };
}, []); // Empty dependency array means this effect runs once on mount

  // Unused state and handlers are removed for cleaner code
  const [formData, setFormData] = useState({
    UserName: "",
    EmailID: "",
    PhoneNumber: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "formSubmissions"), formData);
      alert("Form data saved successfully!");
      setFormData({ UserName: "", EmailID: "", PhoneNumber: "" });
    } catch (error) {
      console.error("Error saving form data:", error);
      alert("An error occurred while saving the form data.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  const faqs = [
    { question: "What is the FE Civil Exam?", answer: "A computer-based exam for aspiring professional engineers, covering fundamental civil engineering topics." },
    { question: "Who is eligible to take the FE Exam?", answer: "Engineering graduates or final-year students from an ABET-accredited program." },
    { question: "How many questions are on the exam?", answer: "110 multiple-choice questions, with a 6-hour duration including a 25-minute break." },
    { question: "What is the passing score?", answer: "The passing score is not fixed; it varies based on overall test performance and difficulty." },
    { question: "How often can I take the FE Exam?", answer: "You can take it up to 3 times in a 12-month period, with a 2-month gap between attempts." },
    { question: "What materials are allowed during the exam?", answer: "Only the FE Reference Handbook (provided digitally) and an NCEES-approved calculator." },
    { question: "How much does the FE Exam cost?", answer: "$175, but some states may have additional costs." },
    { question: "How do I register for the FE Exam?", answer: "Register via the NCEES website, select a test center, and schedule your exam." },
    { question: "How long does it take to get results?", answer: "Results are typically released within 7–10 days on your NCEES account." },
    { question: "What happens after passing the FE Exam?", answer: "You become an Engineer-in-Training (EIT) or Engineering Intern (EI) and can later take the PE Exam for full licensure." }
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "1. Introduction to the FE Civil Exam",
      content: [
        "The Fundamentals of Engineering (FE) Civil Exam is the first step toward professional engineering licensure.",
        "It is designed for recent graduates and students nearing the completion of an ABET-accredited engineering degree.",
        "The exam is administered by the National Council of Examiners for Engineering and Surveying (NCEES) in the U.S."
      ]
    },
    {
      title: "2. Exam Format and Duration",
      content: [
        "The FE Civil Exam is a computer-based test (CBT) conducted at Pearson VUE test centres.",
        "It consists of 110 multiple-choice questions covering key civil engineering topics.",
        "The total exam duration is 6 hours, including a 25-minute break.",
        "It follows a linear-on-the-fly testing (LOFT) format, meaning each candidate gets a unique set of questions.",
        "A digital reference handbook is provided during the exam."
      ]
    },
    {
      title: "3. Exam Topics and Coverage",
      content: [
        "Mathematics & Statistics – Includes calculus, statistics, and probability.",
        "Ethics & Professional Practice – Covers engineering ethics and professional responsibilities.",
        "Engineering Economics – Time value of money, cost analysis, and risk assessment.",
        "Statics – Force systems, equilibrium, and moments of inertia.",
        "Dynamics – Kinematics, energy principles, and force acceleration."
      ]
    },
    {
      title: "4. Scoring and Passing Criteria",
      content: [
        "The FE Exam uses a scaled scoring system, and there is no fixed passing percentage.",
        "The passing score is determined based on the exam difficulty and performance of all test-takers.",
        "Results are released 7–10 days after the exam via the NCEES account.",
        "Candidates receive a Pass/Fail result without detailed score breakdowns."
      ]
    },
    {
      title: "5. Eligibility and Registration",
      content: [
        "The FE Civil Exam is open to engineering graduates or students in their final year of study.",
        "Registration is done through the NCEES website.",
        "Exam fees are $175 (as of 2025) but may vary by state.",
        "Some states may have additional eligibility requirements, so check with your state board."
      ]
    },
    {
      title: "6. Study Materials and Preparation",
      content: [
        "The FE Reference Handbook is the only official material allowed during the exam.",
        "Popular prep books include Lindeburg's FE Civil Review Manual and NCEES Practice Exams.",
        "Practice solving problems quickly since time management is crucial.",
        "Weekly mock tests help improve speed and accuracy.",
        "Formula sheets and shortcuts are useful for last-minute revision.",
        "Focus on conceptual understanding rather than memorization."
      ]
    },
    {
      title: "7. Exam-Day Guidelines",
      content: [
        "Arrive at the test center 30 minutes before the scheduled exam time.",
        "Bring a valid government-issued ID matching your NCEES registration name.",
        "Only NCEES-approved calculators (e.g., Casio FX-115, TI-30X series) are allowed.",
        "Personal items, including phones, smartwatches, and notes, are prohibited.",
        "A scratch pad and marker will be provided for rough work."
      ]
    }
  ];

  const sections1 = [
    {
      title: "1. Introduction to the FE Civil Exam",
      content: [
        "The Fundamentals of Engineering (FE) Civil Exam is the first step toward professional engineering licensure.",
        "It is designed for recent graduates and students nearing the completion of an ABET-accredited engineering degree.",
        "The exam is administered by the National Council of Examiners for Engineering and Surveying (NCEES) in the U.S."
      ]
    },
    {
      title: "2. Exam Format and Duration",
      content: [
        "The FE Civil Exam is a computer-based test (CBT) conducted at Pearson VUE test centres.",
        "It consists of 110 multiple-choice questions covering key civil engineering topics.",
        "The total exam duration is 6 hours, including a 25-minute break.",
        "It follows a linear-on-the-fly testing (LOFT) format, meaning each candidate gets a unique set of questions.",
        "A digital reference handbook is provided during the exam."
      ]
    },
    {
      title: "3. Exam Topics and Coverage",
      content: [
        "Mathematics & Statistics – Includes calculus, statistics, and probability.",
        "Ethics & Professional Practice – Covers engineering ethics and professional responsibilities.",
        "Engineering Economics – Time value of money, cost analysis, and risk assessment.",
        "Statics – Force systems, equilibrium, and moments of inertia.",
        "Dynamics – Kinematics, energy principles, and force acceleration."
      ]
    },
    {
      title: "4. Scoring and Passing Criteria",
      content: [
        "The FE Exam uses a scaled scoring system, and there is no fixed passing percentage.",
        "The passing score is determined based on the exam difficulty and performance of all test-takers.",
        "Results are released 7–10 days after the exam via the NCEES account.",
        "Candidates receive a Pass/Fail result without detailed score breakdowns."
      ]
    },
    {
      title: "5. Eligibility and Registration",
      content: [
        "The FE Civil Exam is open to engineering graduates or students in their final year of study.",
        "Registration is done through the NCEES website.",
        "Exam fees are $175 (as of 2025) but may vary by state.",
        "Some states may have additional eligibility requirements, so check with your state board."
      ]
    },
    {
      title: "6. Study Materials and Preparation",
      content: [
        "The FE Reference Handbook is the only official material allowed during the exam.",
        "Popular prep books include Lindeburg's FE Civil Review Manual and NCEES Practice Exams.",
        "Practice solving problems quickly since time management is crucial.",
        "Weekly mock tests help improve speed and accuracy.",
        "Formula sheets and shortcuts are useful for last-minute revision.",
        "Focus on conceptual understanding rather than memorization."
      ]
    },
    {
      title: "7. Exam-Day Guidelines",
      content: [
        "Arrive at the test center 30 minutes before the scheduled exam time.",
        "Bring a valid government-issued ID matching your NCEES registration name.",
        "Only NCEES-approved calculators (e.g., Casio FX-115, TI-30X series) are allowed.",
        "Personal items, including phones, smartwatches, and notes, are prohibited.",
        "A scratch pad and marker will be provided for rough work."
      ]
    }
  ];
  

  return (
    <div>
      {/* Existing Section */}
      {/* Existing Section */}
      {/* Existing Section */}
<div className="banner-section">
  <div className="container">
    <div className="row justify-content-around align-items-center">
      {/* Left Section */}
      <div className="left-section col-md-6">
        <h1 className="heading">Data Engineering Course.</h1>
        <h3 className="subheading">
          From Design To Implementation!
        </h3>
        <ul>
                <li>100% Placement Support</li>
                <li>Industry Led Curriculum</li>
                <li>Hands-on Training</li>
                <li>40+ Projects</li>
                <li>Edufulness Certification</li>
              </ul>
        <h4 className="live-class">
          Live Online Classes | 14th September 2025 08:00 PM IST
        </h4>
      </div>

      {/* Right Section */}
      <div className="right-section col-md-5 bg-light shadow rounded p-4 mx-auto">
        {/* Form Heading */}
        <h2 className="text-center mb-3">JOIN THE COURSE</h2>
        {/* Live Class Alert */}
        
        {/* Form */}
        <img
  src="/images/dataEng.jpg"
  alt="Future of Data Engineering"
  className="img-fluid"
  style={{
    margin: '20px auto',
    display: 'block',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    maxWidth: '100%',
    marginBottom: '20px'
  }}
/>
        <a href="#start-learning-section" className="btn btn-primary whyChooseModalButton">
          Enroll Now
        </a>
      </div>
    </div>
  </div>
</div>
{/* New Section: Azure Data Engineering Courses start*/}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="fw-bold">
              AZURE DATA ENGINEERING <span className="text-primary">COURSE</span>
            </h2>
            <p className="text-muted">
              (Data Factory + Databricks with PySpark + Synapse Analytics + SQL Server)
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-3 text-center mb-4">
              <div className="shadow-left">
                <img
                  src="https://www.pvrcloudtech.com/wp-content/uploads/Azure-Data-Factory.png"
                  alt="Azure Data Factory"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3 text-center mb-4">
              <div className="shadow-left">
                <img
                  src="https://www.pvrcloudtech.com/wp-content/uploads/PySpark-Databricks.png"
                  alt="Databricks with PySpark"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3 text-center mb-4">
              <div className="shadow-left">
                <img
                  src="https://www.pvrcloudtech.com/wp-content/uploads/Synapse-Analytics.jpeg"
                  alt="Azure Synapse Analytics"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3 text-center mb-4">
              <div className="shadow-left">
                <img
                  src="/images/SQL1.jpg"
                  alt="SQL Server"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        {/*<!-- description about edufulness starts here -->*/}
         {/* New Section: Image & Description */}
         <section className="py-5 bg-white">
  <div className="container">
    <div className="row align-items-center">
      {/* Image Section */}
      <div className="col-md-6 text-center">
        <div className="image-container">
          <img
            src="/images/img-project-feedback.jpg"
            alt="Project Feedback"
            className="img-fluid custom-image"
          />
        </div>
      </div>

      {/* Description Section */}
      <div className="col-md-6">
  <h2 className="fw-bold">Description</h2>
  <p className="description-text" style={{ maxWidth: '500px', textAlign: 'justify', fontFamily: 'Montserrat', fontWeight: '400' }}> 
  Edufulness Certified Advanced Programmer with Data Engineer Mastery 
  Program is a leading-edge Technological Program paving your way to an 
  assured lucrative career. It is an integrated course directed by 
  Edufulness. Instructed by the industry’s best Technical Experts, this 
  program offers mentorship through Data Engineering Experts and 
  directs you to the Fortune 500 companies. The vision is to make the 
  premium organizations discover the Right Talent.
</p>
</div>
    </div>
  </div>
</section>

<section
  className="d-flex justify-content-center align-items-center"
  style={{
    minHeight: "100vh", // Full viewport height
    textAlign: "center", // Center text
    padding: "20px", // Add padding for smaller screens
    boxSizing: "border-box", // Ensure padding doesn't affect width
    overflowX: "hidden", // Prevent horizontal overflow
  }}
>
  <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
    <h2 className="text-center mb-4">
      Steps to become an Expert Data Engineer
    </h2>

    {/* Wrapper for SimpleGrid */}
    <Roadmap />
  </div>
</section>
   {/*<!-- description about edufulness ends here -->*/}
      </section>
      {/* New Section: Azure Data Engineering Courses end*/}
    
      
     {/*Why edufulness section start */}
     <section style={{ margin: "10px 0", fontFamily: "'Roboto', sans-serif" }}>
  <Container>
    <Row className="align-items-center">
      <Col md={6}>
        <h2 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>
          Why Edufulness
        </h2>
        <p style={{ fontSize: "1.2rem", lineHeight: "1.5" }}>
          Edufulness's Snowflake Course is  Project Based Career
          Programs that promises  Placement Support on completing
          the course. Here theory and practical go hand-in-hand, placing
          you in top companies with high salaries.
        </p>
        {/* Button to trigger the modal */}
        <a 
          href="#start-learning-section"
          className="btn btn-primary whyChooseModalButton"
        >
          Enroll Now
        </a>
      </Col>
      <Col md={6}>
        <img
          src="/images/about_image.png"
          alt="why"
          style={{ width: "80%", height: "auto" }}
        />
      </Col>
    </Row>
  </Container>

  {/* Bootstrap Modal */}
  <div
    className="modal fade"
    id="exampleModal"
    tabIndex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered modal-lg">
      {/* Added 'modal-lg' for a larger modal */}
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Enroll Now
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          {/* RegistrationForm Component */}
          <RegistrationForm />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
   
    {/*Why edufulness section end */}
     
    
    {/* Program Overview start*/}
    <section style={{ fontFamily: 'sans-serif' }}> 
      <div className="overview">
       <div className="container">
  <div className="row overview_row">
    <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>Program Eligibility And Overview</h2>
    <p className="text-center pb-4" style={{ fontSize: '1rem', fontFamily: 'Montserrat', fontWeight: '400' }}> 
      Check the only eligibility criteria <br />
      Students & Working Professionals, seeking opportunities to upskill their Data Engineering proficiency for faster career growth.
    </p>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>A program designed by IIT Experts</h5> 
        </div>
      </div>
    </div>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>Live Online Classes + Lifetime recorded videos</h5> 
        </div>
      </div>
    </div>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>One-on-One with Mentors</h5> 
        </div>
      </div>
    </div>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>Ask me anything sessions with Industry Experts</h5> 
        </div>
      </div>
    </div>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>Globally Recognized Certification from Edufulness</h5> 
        </div>
      </div>
    </div>

    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow bg-light" style={{ border: 'none', borderRadius: '0', minHeight: '100px' }}> 
        <div className="card-body d-flex align-items-center justify-content-center"> 
          <h5 style={{ fontSize: '1.2rem', fontFamily: 'Montserrat', fontWeight: '600' }}>A digital portfolio through "Github"</h5> 
        </div>
      </div>
    </div>
  </div>
</div>
      </div>
    </section>
    {/*Program Overview end */}
{/* Take advantage of current price start */}
{/* <section style={{
        backgroundColor: '#333',
        color: '#fff',
        padding: '20px',
        textAlign: 'center',
        borderRadius: '5px',
        maxWidth: '580px',
        margin: '0 auto'
      }}>
        <div className="offer-content">
          <h2 style={{ fontSize: '24px', marginBottom: '15px' }}>Take Advantage of Our Current Price</h2>
          <div className="price">
            <h3 style={{ fontSize: '18px', marginBottom: '5px' }}>Program Fee</h3>
            <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
              <span style={{ textDecoration: 'line-through' }}>₹{coursePrice.previousPrice}</span> ₹{coursePrice.currentPrice} (Inc taxes)
            </p>
          </div>
          <p style={{ fontSize: '14px', color: '#ff0000', marginBottom: '10px' }}>Limited Time Offer!</p>
          <p>Evaluate the Pre-bootcamp (Free Sessions)</p>
          <p>with 100% Refund Guarantee</p>
          <p>7-Day Refund Policy</p>
          <Row className="justify-content-center">
            <Col md={4} className="text-center">
              <button
                type="button"
                className="btn btn-primary whyChooseModalButton"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Apply Now
              </button>
            </Col>
          </Row>
        </div>
      </section> */}
    
    
    {/* Speaker Section */}
    <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-blue-800 mb-10">Meet Your Instructor</h2>
            <div className="flex justify-center gap-12">
                
                <div className="bg-white p-8 rounded-xl shadow-lg md:w-2/3 flex flex-col md:flex-row items-center gap-8">
                    <img src="/images/atchyut.jpg" alt="Atchyut Kumar" className="w-48 h-48 rounded-full object-cover ring-4 ring-blue-200 flex-shrink-0"/>
                    <div className="text-center md:text-left">
                        <h3 className="text-2xl font-bold text-gray-900">Atchyut Kumar</h3>
                        <p className="text-blue-600 font-semibold mb-2">M.Tech in Computer Science from NIT Calicut</p>
                        <p className="text-gray-600">Atchyut is a seasoned data professional with over a decade of experience in building scalable data pipelines and leading data-driven initiatives at top tech companies. He is passionate about mentoring the next generation of data engineers.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/*Program Overview end */}
{/* Take advantage of current price start */}
{/* <section style={{ 
      backgroundColor: '#333', 
      color: '#fff', 
      padding: '20px', 
      textAlign: 'center',
      borderRadius: '5px', 
      maxWidth: '580px', 
      margin: '0 auto' 
    }}> 
      <div className="offer-content"> 
        <h2 style={{ fontSize: '24px', marginBottom: '15px' }}>Take Advantage of Our Current Price</h2>
        <div className="price">
          <h3 style={{ fontSize: '18px', marginBottom: '5px' }}>Program Fee</h3>
          <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
  <span style={{ textDecoration: 'line-through' }}>₹{coursePrice.previousPrice}</span> ₹{coursePrice.currentPrice} (Inc taxes)
</p>
        </div>
        <p style={{ fontSize: '14px', color: '#ff0000', marginBottom: '10px' }}>Limited Time Offer!</p>
        <p>Evaluate the Pre-bootcamp (Free Sessions)</p>
        <p>with 100% Refund Guarantee</p>
        <p>7-Day Refund Policy</p>
        <Row className="justify-content-center">
  <Col md={4} className="text-center">
    <button
              type="button"
              className="btn btn-primary whyChooseModalButton"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              Apply Now
            </button>  </Col>
</Row>
      </div>
    </section> */}
{/* Take advantage of current price end*/}
 {/*Master Data Engineering section start */}
<section id="start-learning-section" style={{
  backgroundColor: '#101743',
  color: '#fff',
  padding: '50px 0',
  fontFamily: "'Roboto', sans-serif"
}}>
  <div className="container">
    <div className="row align-items-center">
      {/* Left Column: Heading and Description */}
      <div className="col-md-6 text-center text-md-start">
        <h2 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>
          Master Data Engineering with Edufulness certification for becoming an Advanced Data Professional
        </h2>
        <p style={{ fontSize: "1.2rem", lineHeight: "1.5" }}>
          Fill out the form to start your journey towards becoming a certified Snowflake professional and land your dream job with our comprehensive course and placement support.
        </p>
      </div>

      {/* Right Column: Zoho Form inside a column */}
      <div className="col-md-6">
        <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px' }}>
          <iframe 
            frameBorder="0" 
            id="iframewin" 
            width="100%" 
            height="500px" // Adjust the height as needed
            src="https://flns-zc1.maillist-manage.in/ua/Optin?od=1a1e3dbd54071&zx=1dfae70591&tD=13bf55090b690a49&sD=13bf55090b6d388b">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</section>
{/* <section style={{ 
      backgroundColor: '#101743',
      color: '#fff', 
      padding: '50px 0',
      textAlign: 'center' 
    }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12">
            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Master Snowflake with Edufulness certification 
              for becoming an Advanced Data Professional</h2>
              <Row className="justify-content-center">
  <Col md={4} className="text-center">
  <button
              type="button"
              className="btn btn-primary whyChooseModalButton"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              Start Learning
            </button>  </Col>
</Row>
          </div>
        </div>
      </div>
    </section> */}
    {/*Master Data Engineering section end */}

    {/*Where students work start */}
    {/*Youtue link start*/}

<section>
<div class="youtube">
    <div class="container">
      <div class="row justify-content-center pt-5">
        <div class="col-md-6">
          <div class="ratio ratio-16x9 pt-5">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/lWqrs9AhH4Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-md-5">
          <h1 class="text-center pt-5">Explore the <br/>AZURE DATA ENGINEER</h1>
          <div class="channelLink text-center pt-4">
            <h3 class="chanlink pb-3">Subscribe to our channel to<br/> more update </h3>
            <button type="button" class="btn btn-primary btn-lg">
  <a
    class="channellink text-white text-decoration-none"
    href="https://www.youtube.com/@EduFulnessEFN"
    target="_blank"
  >
    Subscribe Now
  </a>
</button>
          </div>
        </div>
       </div>
    </div>
   </div>


</section>


  {/*Youtube link end*/}
    {/*Where students work start */}
   





<div className="container mt-5">
      
      {/*FAQS*/}
      <section>
        
      <SimpleAccordion/>

      </section>
    </div>


  

  




    



    </div>
  );
};

export default Banner2;
